import React from 'react';
import logo from '../assets/logo.webp';
import { useLanguage } from '../context/LanguageContext';
import { useTheme } from '../context/ThemeContext';
import { navigationTranslations } from '../data/translations/navigationTranslations';

export default function Navbar() {
  const { language, toggleLanguage } = useLanguage();
  const { theme, toggleTheme } = useTheme();
  const t = navigationTranslations[language].nav;

  const navItems = [
    { id: 'about', label: t.about },
    { id: 'benefits', label: t.what },
    { id: 'servicios', label: t.portfolio },
    { id: 'team', label: t.team },
    { id: 'news', label: t.news },
  ];

  return (
    <header className="anim-slide-down fixed top-0 w-full z-50 bg-background/80 backdrop-blur-md border-b border-border shadow-sm transition-all duration-300">
      <nav className="flex justify-between items-center w-full px-8 py-5 max-w-screen-2xl mx-auto font-body font-semibold text-on-background">

        {/* Logo Section */}
        <div className="flex items-center gap-2">
          <a href="/#home" className="hover:opacity-80 transition-opacity">
            <img src={logo} alt="Intelimed Logo" className={`h-9 object-contain ${theme === 'dark' ? 'brightness-0 invert' : ''}`} />
          </a>
        </div>

        {/* Navigation Links - Dynamic */}
        <div className="hidden lg:flex items-center gap-10">
          {navItems.map(item => (
            <a
              key={item.id}
              className="text-muted hover:text-primary transition-colors text-[10px] uppercase tracking-[0.2em] font-black"
              href={`/#${item.id}`}
            >
              {item.label}
            </a>
          ))}
        </div>

        {/* Action Group */}
        <div className="flex items-center gap-5">
          {/* Language Toggle */}
          <button
            onClick={toggleLanguage}
            className="px-3 py-1.5 rounded-lg bg-surface border border-border text-primary font-black text-[10px] uppercase tracking-widest hover:text-secondary hover:border-secondary/40 transition-all flex items-center gap-2"
            aria-label="Change language"
          >
            <span className="opacity-40">{language === 'es' ? 'EN' : 'ES'}</span>
            <span>{language.toUpperCase()}</span>
          </button>

          {/* Theme Toggle */}
          <button
            onClick={toggleTheme}
            className="w-10 h-10 flex items-center justify-center rounded-full bg-surface border border-border text-on-surface hover:text-secondary transition-all"
            aria-label="Toggle theme"
          >
            <span className="material-symbols-outlined text-xl">
              {theme === 'light' ? 'dark_mode' : 'light_mode'}
            </span>
          </button>

          <button
            className="bg-primary text-on-primary px-8 py-3 rounded-xl font-headline font-black text-[10px] uppercase tracking-widest hover:bg-secondary hover:text-on-secondary transition-all active:scale-95 shadow-lg"
            onClick={() => {
              const el = document.getElementById('contact');
              if (el) el.scrollIntoView({ behavior: 'smooth' });
              else window.location.href = '/#contact';
            }}
          >
            {t.contact}
          </button>
        </div>
      </nav>
    </header>
  );
}
// Upgraded Navbar with Theme Toggle and better A11y.